module.exports = __webpack_public_path__ + "static/media/receive-payments-icon.5ac74963.svg";